import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'

export const hasBudgetPlaces = (trainingForms: IProgramId['trainingForms']): boolean => {
  if (trainingForms) {
    return trainingForms.some((item) => {
      return item.hasBudget
    })
  }

  return false
}
